export default {
  // 创建项目
  getLineList: {
    url: '/lineApi/getLineList',
    method: 'POST'
  },
  // 获取项目列表
  newLine: {
    url: '/lineApi/newLine',
    method: 'POST'
  },
}